export function requireValue<T>(value: T | null | undefined): T {
  if (value == null) throw new Error('Expected value to be present.');
  return value;
}
